import React from "react";
import { motion } from "framer-motion";
import clsx from "clsx";

// Vertical animated flow of labelled nodes joined by a dashed connector.
export const FlowDiagram = ({ steps, dark = true, highlightLast = true, compact = false }) => {
  const line = dark ? "rgba(255,255,255,0.14)" : "rgba(10,10,11,0.12)";
  return (
    <div className="relative" data-testid="flow-diagram">
      {/* connector */}
      <svg
        className="absolute left-[18px] top-4 h-[calc(100%-2rem)] w-px overflow-visible"
        preserveAspectRatio="none"
      >
        <line x1="0" y1="0" x2="0" y2="100%" stroke={line} strokeWidth="1.5" />
        <line x1="0" y1="0" x2="0" y2="100%" stroke="#008753" strokeWidth="1.5" className="dash-flow" />
      </svg>

      <ul className={clsx("relative space-y-0", compact ? "" : "")}>
        {steps.map((step, i) => {
          const isLast = i === steps.length - 1;
          const active = highlightLast && isLast;
          return (
            <motion.li
              key={step}
              className={clsx("flex items-center gap-4", compact ? "py-2.5" : "py-3.5")}
              initial={{ opacity: 0, x: -18 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.09, ease: [0.16, 1, 0.3, 1] }}
            >
              <span
                className={clsx(
                  "relative z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-mono text-[0.7rem]",
                  active
                    ? "bg-govx-lime text-govx-black"
                    : dark
                    ? "border border-white/15 bg-govx-black text-govx-grey"
                    : "border border-govx-charcoal/15 bg-govx-paper text-govx-grey"
                )}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <span
                className={clsx(
                  "font-display text-base font-medium tracking-tight sm:text-lg",
                  active ? (dark ? "text-govx-lime" : "text-govx-green") : dark ? "text-govx-paper" : "text-govx-charcoal"
                )}
              >
                {step}
              </span>
            </motion.li>
          );
        })}
      </ul>
    </div>
  );
};
